import { atom, selector } from 'recoil';
import { createFieldSelector } from '@zurich/common/recoil';
import { offerAtom } from '../atoms/';
const offerSelectorHelper = createFieldSelector(offerAtom);
//TODO: move to atoms
export const showPaymentWarningDialog = atom({
    key: 'showPaymentWarningDialog',
    default: false,
});
export const documentsSelector = offerSelectorHelper('documents', {
    defaultValue: [],
});
export const productsSelector = offerSelectorHelper('products', {
    defaultValue: [],
});
export const insuredObjectsSelector = offerSelectorHelper('insuredObjects', {
    defaultValue: [],
});
export const paymentIntervalSelectorInternal = offerSelectorHelper('paymentInterval', {
    defaultValue: undefined,
});
export const paymentIntervalSelector = selector({
    key: 'paymentIntervalSelector',
    get: ({ get }) => get(paymentIntervalSelectorInternal),
    set: ({ set, get }, paymentInterval) => {
        const paymentWay = get(paymentWaySelectorInternal);
        if (paymentWay === 'Zentralinkasso' && paymentInterval === 'monthly') {
            set(showPaymentWarningDialog, true);
            return;
        }
        set(paymentIntervalSelectorInternal, paymentInterval);
    },
});
export const paymentWaySelectorInternal = offerSelectorHelper('paymentWay', {
    defaultValue: undefined,
});
export const paymentWaySelector = selector({
    key: 'paymentWaySelector',
    get: ({ get }) => get(paymentWaySelectorInternal),
    set: ({ set, get }, paymentWay) => {
        const paymentInterval = get(paymentIntervalSelectorInternal);
        if (paymentWay === 'Zentralinkasso' && paymentInterval === 'monthly') {
            set(showPaymentWarningDialog, true);
            return;
        }
        set(paymentWaySelectorInternal, paymentWay);
    },
});
export const stateSelector = offerSelectorHelper('state', {
    defaultValue: null,
});
